module.exports = {
    catalogUrl: null,
    catalogTitle: "USGS EROS STAC Browser",
    catalogImage: null,
    allowExternalAccess: false,
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
        "ar",
//      "de-CH",
        "es",
        "en",
//      "en-GB",
//      "en-US",
        "fr",
//      "fr-CA",
//      "fr-CH",
        "it",
//      "it-CH",
        "ro",
        "ja",
        "pt",
//      "pt-BR",
        "id",
        "pl"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    displayGeoTiffByDefault: false,
    displayPreview: false,
    displayOverview: false,
    buildTileUrlTemplate: null,
    getMapSourceOptions: function(type, options, asset) {
        // Non-rectangular images (like EO-1) stored in a rectangular bounding box with black fill 
        // (value 0) outside the data area. If the GeoTIFF does not embed a nodata tag, this renders 
        // as an opaque black box. Inject nodata: 0 for sources that don't already declare one.
        if (type.toString() === 'GeoTIFF' && Array.isArray(options.sources)) {
            options.sources = options.sources.map(function(source) {
                if (typeof source.nodata === 'undefined') {
                    return Object.assign({}, source, { nodata: 0, min: 1 });
                }
                return source;
            });
        }
        return options;
    },
    pathPrefix: "/",
    historyMode: "history",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showKeywordsInItemCards: false,
    showKeywordsInCatalogCards: false,
    showThumbnailsAsAssets: true,
    searchResultsPerPage: null,
    itemsPerPage: null,
    collectionsPerPage: null,
    maxEntriesPerPage: 1000,
    defaultThumbnailSize: null,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    socialSharing: ['email', 'bsky', 'mastodon', 'x'],
    preprocessSTAC: (stac, state) => { 
        // Giving the root catalog a better description 
        if (stac.getBrowserPath() === '/') {
            stac.description = 'This STAC Browser is based on the open-source Radiant Earth STAC Browser, it allows you to browse and download data products archived at the USGS EROS.\n\nStart by selecting your desired product below. Click the \'Show Filters\' icon to select a date range or spatial extent, and your preferred sort option. When you click Submit, the results will be available to review.';
        }
        return stac;
    },
    authConfig: null,
    crs: {},
    footerLinks: [
        { title: "Visit DOI Privacy Policy Page", label: "DOI Privacy Policy", url: "https://www.doi.gov/privacy" },
        { title: "Visit USGS Legal Page",         label: "Legal", url: "https://www.usgs.gov/laws/policies_notices.html" },
        { title: "Visit USGS Accessibility Page", label: "Accessibility", url: "https://www2.usgs.gov/laws/accessibility.html" },
        { title: "Visit USGS Site Map Page",      label: "Site Map", url: "https://www.usgs.gov/sitemap.html" },
        { title: "Visit Contact USGS Page",       label: "Contact USGS", url: "https://answers.usgs.gov/" },
        { title: "Visit U.S. Department of the Interior Page", label: "U.S. Department of the Interior", url: "https://www.doi.gov/" },
        { title: "Visit DOI Inspector General Page", label: "DOI Inspector General", url: "https://www.doioig.gov/" },
        { title: "Visit White House Page",        label: "White House", url: "https://www.whitehouse.gov/" },
        { title: "Visit E-gov Page",              label: "E-gov", url: "https://www.whitehouse.gov/omb/management/egov/" },
        { title: "Visit No Fear Act Page",        label: "No Fear Act", url: "https://www.doi.gov/pmb/eeo/no-fear-act" },
        { title: "Visit FOIA Page",               label: "FOIA", url: "https://www2.usgs.gov/foia" }
    ],
    thumbnailAPIEndpoint: null
};
